import { useState } from "react";

export default function GroupAvatar({ src, size = 40 }) {
  const [hover, setHover] = useState(false);

  const getGradient = (id) => {
  const colors = [
    ["#ff7a7a", "#ffb86b"],
    ["#6bcBff", "#4c8dff"],
    ["#a18cd1", "#fbc2eb"],
    ["#43e97b", "#38f9d7"],
    ["#fa709a", "#fee140"],
  ];

  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }

  return colors[Math.abs(hash) % colors.length];
};
const gradient = getGradient(src || "group");

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        overflow: "hidden",
        position: "relative",

        background: "rgba(255,255,255,0.05)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255,255,255,0.08)",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        transform: hover ? "scale(1.08)" : "scale(1)",
        transition: "0.25s ease",
      }}
    >
      {/* ЕСЛИ ЕСТЬ АВАТАР */}
      {src ? (
        <img
          src={src}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        <>
          {/* fallback SVG */}
          <svg
            width={size * 0.6}
            height={size * 0.6}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
              color: "#fff",
              opacity: 0.9,
              transform: hover ? "scale(1.1)" : "scale(1)",
              transition: "0.25s",
            }}
          >
            <circle cx="12" cy="9" r="3.2" />
            <path d="M6.5 18c0-2.6 2.6-4.5 5.5-4.5s5.5 1.9 5.5 4.5" />
            <circle cx="5.5" cy="10" r="2.2" opacity="0.6" />
            <path d="M2.5 18c0-1.8 1.8-3.2 3.8-3.2" opacity="0.6" />
            <circle cx="18.5" cy="10" r="2.2" opacity="0.6" />
            <path d="M21.5 18c0-1.8-1.8-3.2-3.8-3.2" opacity="0.6" />
          </svg>

          {/* subtle glow */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              borderRadius: "50%",
              background: src
  ? "rgba(255,255,255,0.05)"
  : `linear-gradient(135deg, ${gradient[0]}, ${gradient[1]})`,
              opacity: hover ? 1 : 0,
              transition: "0.3s",
            }}
          />
        </>
      )}
    </div>
  );
}